import { defineStore } from 'pinia';
import { useRoute } from 'vue-router';
import { useAppStore } from './app';
import { useUserStore } from './user';
import Filter from '../types/interfaces/services/Filter';
import { Services } from '../types/interfaces/services/Services';
import { ApImportantMessage } from '../types/interfaces/services/ApImportantMessage';

// eslint-disable-next-line import/prefer-default-export
export const useServicesStore = defineStore({
	id: 'services',
	state: () => ({
		displaySaveChanges: false,
		isNewCategory: false,
		currentPage: '',
		selectedCategoryGroupId: 0,
		groupsToRemove: [] as {
			isSelected: boolean;
			categoryId: number;
			categoryName: string;
		}[],
		selectedFilterIndex: 0,
		isEditMatching: false,
		isEditLocations: false,
		isFreshCategory: false,
		suspendFilterStatus: '',
		filterToRemove: {
			id: 0,
			type: '',
			categoryId: 0,
		},
		isFilterDirty: false,
		isInsideFilterDetails: false,
		pricingCategoryId: 0,
		customerId: useAppStore().isAdminModule ? Number(useRoute()?.params?.id) : useUserStore().customerId,
		isRecommendationFeedbackModalVisible: false,
		notifications: {
			recommendation: {
				type: '',
				title: '',
				message: '',
				button: '',
				dismissButton: '',
				moreInfoLink: '',
				isVisible: false,
			},
		},
		invalidStats: false,
		isLoading: false,
		isFreeRecommendationConfirmationModalVisible: false,
		potentialMatches: -1,
		visibilityTenPercentDiscountConfirmationModal: false,
	}),
	actions: {
		/**
		 * Zwraca tablicę z aktualnym filtrem oraz tym znajdującym się w drzewie.
		 * Używamy tego sposobu, kiedy chcemy zmienić jakąś informację, a nie chcemy
		 * pobierać całej listy na nowo
		 */
		selectedFilters({ selectedFilter, servicesObject }: {selectedFilter: Filter, servicesObject: Services}) : Filter[] {
			// @TODO - przenieść selectedFilter, servicesObject do store

			const { categoryId } = selectedFilter.category;
			const foundGroup = servicesObject.tree.find((group) => group.categoryId === categoryId);
			const foundFilter = foundGroup?.filters.find((filter) => filter.id === selectedFilter.id);

			return foundFilter ? [selectedFilter, foundFilter] : [];
		},
		setNotifications(apImportantMessage: ApImportantMessage) {
			this.notifications.recommendation = {
				type: apImportantMessage.type || 'info',
				title: apImportantMessage.title,
				message: apImportantMessage.message.replace(/<br>/g, ''),
				button: apImportantMessage.buttonLabel || 'Dowiedz się więcej',
				dismissButton: apImportantMessage.dismissButtonLabel || 'Przypomnij później',
				moreInfoLink: apImportantMessage.moreInfoLink,
				isVisible: true,
			};
		},
		labelClasses(filter?: Filter) {
			if (!filter || !filter.isActive) {
				return 'bg-[#F2F2F2] text-[#666666]';
			}

			if (this.isFilterInactive(filter)) {
				return 'bg-[#FBEAE8] text-[#DA291C]';
			}

			if (filter.tsSuspendedEnd && this.isSuspended(filter)) {
				return 'bg-[#E7EFFB] text-[#1462D3]';
			}

			return 'bg-[#E7F3EF] text-[#0E875F]';
		},

		/**
		 * Czy filtr jest nieaktywny? (filter.isActive === false a isFilterInactive to nie to samo,
		 * pierwsze oznacza że został wyłączony ręcznie, drugie że został wyłączony automatycznie przez niespełniające warunki serwisu)
		 */
		isFilterInactive(filter: Filter) {
			return filter.type === 'automatic' && (
				filter.notEnoughPoints
				|| filter.finalMarkBelowApThreshold
				|| filter.weeklyLimitReached
				|| !filter.apValidated
			);
		},

		/**
		 * Sprawdza, czy podany filtr Polecania lub Szybkiego Kontaktu jest zawieszony.
		 * @param {Filter} filter - Filtr do sprawdzenia
		 */
		isSuspended(filter: Filter) {
			return filter.isActive
			&& filter.tsSuspendedEnd
			&& filter.tsSuspendedEnd > Date.now()
			&& (filter.type === 'automatic' || filter.type === 'quick');
		},
	},
});
